module.exports = __webpack_public_path__ + "static/media/BlackOvis.png.098a3d81.webp";